import { render, staticRenderFns } from "./KeysPanel.vue?vue&type=template&id=9a3a6742&"
import script from "./KeysPanel.vue?vue&type=script&lang=ts&"
export * from "./KeysPanel.vue?vue&type=script&lang=ts&"
import style0 from "./KeysPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports